/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import './labelCellRenderer.style.css';

const LabelCellRenderer = ({ data, value }) => {
    const handleClick = () => {
        data.cellClicked(data.key);
    };

    if (data.isSubRow) return <div className="LabelCellRendererSubRow">{value}</div>;
    if (!data.children) return value;

    let faCode = 'fa-caret-right';
    if (data.expanded) {
        faCode = 'fa-caret-down';
    }
    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div className="LabelCellRenderer" onClick={handleClick}>
            <i className={`fa ${faCode}`}></i>
            {value}
        </div>
    );
};

export default LabelCellRenderer;
